module.exports = __webpack_public_path__ + "img/logo.095cd075.png";